<template>
  <div class="flex flex-col">
    <div class="px-4 pt-4">
      <div class="flex">
        <div
          class="font-bold text-md flex items-center justify-center leading-normal"
        >
          <span v-text="label"></span>
        </div>
        <div class="flex-grow"></div>
        <div
          v-on:click="peek"
          v-show="hint"
          class="flex items-center justify-center h-icon w-icon"
        >
          <img v-bind:src="getIcon()" />
        </div>
      </div>
    </div>
    <div class="w-full flex items-center justify-center my-5">
      <!-- <NumberInputControl
        :length="length"
        :value="pin"
        :hidden="hidden"
        @typing="typing"
        @complete="complete"
      /> -->
      <v-otp-input :is-disabled="false" ref="pinOTP" input-classes="otp-input" :input-type="hidden ? 'password' : 'text'"
                    inputmode="numeric" :num-inputs="length" v-model:value="pin" :should-auto-focus="true"
                    :should-focus-order="true" :key="otpInputKey" @on-complete="complete" @on-change="typing" />
    </div>
  </div>
</template>

<script>
// import NumberInputControl from "./../../components/controls/NumberInputControl.vue";
import VOtpInput from "vue3-otp-input";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  components: {
    // NumberInputControl,
    VOtpInput
  },
  props: {
    label: {
      type: String,
    },
    hint: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      length: 6,
      hidden: true,
      pin: "",
    };
  },
  mounted() {
    if (this.value != null) {
      this.pin = this.value;
    }
  },
  methods: {
    typing(obj) {
      this.$emit("typing", obj);
    },
    complete(value) {
      this.$emit("complete", value);
    },
    peek() {
      this.hidden = !this.hidden;
    },
    getIcon() {
      return require(!this.hidden
        ? "@/assets/icons/papsi_password_visible.svg"
        : "@/assets/icons/papsi_password_invisible.svg");
    },
  },
  watch: {
    value(value) {
      this.pin = value;
    },
  },
};
</script>

<style scoped>

</style>
